import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { usePageMeta } from '../../utils/pageMeta';
import { getPodkategorijaById, getSkupOblastiByPodkategorijaId } from '../../server/server-kategorije-tree';
import { useUser } from '../../auth/UseUser';
import { TypeOfEtity } from '../../model/enum/typeOfEntity';
import { Oval } from 'react-loader-spinner';
import { ObrazovanjeItem } from './ObrazovanjeHome';

function PodkategorijaObrazovanjeHome() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const { navLista, setNavLista, returnedList, setReturnedList, setTipEtiteta } = useUser();
    const [mainList, setMainList] = useState<any[]>([]);
    const [podkategorija, setPodkategorija] = useState<any>(null);
    usePageMeta(podkategorija?.naziv, podkategorija?.opis);

    useEffect(() => {
        if (!!id) loadPodkategorija();
    }, [id]);

    const loadPodkategorija = async () => {
        setLoading(true);
        const resp = await getPodkategorijaById(id);
        if (resp.status == 200) {
            const item = resp.data;
            setPodkategorija(resp.data);
            let newList: any[] = [];
            if (item.kategorija) newList.push(item.kategorija);
            newList.push(item);
            setNavLista(newList);
            setTipEtiteta(TypeOfEtity.SkupOblasti);
            setReturnedList(resp.data.skupoviOblasti);
            setMainList(resp.data.skupoviOblasti);
            setLoading(false);
        } else {
            setLoading(false);
        }
    };

    const loadSkupOblasti = async (id: string | undefined) => {
        const resp = await getSkupOblastiByPodkategorijaId(id);
        if (resp.status === 200) {
        }
    };

    return (
        <div className="flex-1 flex h-full flex-col items-center overflow-y-auto bg-blueDark  no-scroll">
            <div className=" obrazovanje-outer-frame-mobile lg:obrazovanje-outer-frame-web">
                <div className=" obrazovanje-inner-frame-mobile sm:obrazovanje-inner-frame-web">
                    {!loading && (
                        <>
                            <p className=" text-obrazovanje-title">
                                {podkategorija?.naziv}: <span className="text-white">{podkategorija?.opis}</span>
                            </p>
                            <div className="mt-6 flex flex-col gap-3">
                                {returnedList.map((item: any, index: number) => {
                                    return <ObrazovanjeItem key={index} item={item} />;
                                })}
                            </div>
                        </>
                    )}
                    {loading && (
                        <div className="w-full flex-1 flex items-center justify-center">
                            <Oval />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default PodkategorijaObrazovanjeHome;
